import { Component, Inject, OnDestroy } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { AuthorizedApiService } from '../../services/authorized-api.service';
import { Subscription } from 'rxjs';
import { DialogButtonComponent } from "../buttons/dialog-button.component";

@Component({
  standalone: true,
  imports: [DialogButtonComponent],
  template: `
    <div class="bg-theme-surface rounded-2xl shadow-xl w-80">
      <div class="p-6 w-96 max-w-full relative">
        <h2 class="text-xl font-bold mb-4">{{ modalData?.title }}</h2>
        <p>{{ modalData?.message }}</p>
        <div class="mt-4 flex gap-2 justify-end">
          <app-dialog-button
            [text]="modalData?.abortText || 'Avbryt'"
            (onClick)="close(false)">
          </app-dialog-button>
          <app-dialog-button
            [text]="modalData?.confirmText || 'Ok'"
            (onClick)="positive()"
            variant="warning">
          </app-dialog-button>
        </div>
      </div>
    </div>
  `
})
export class ConfirmDialogComponent implements OnDestroy {
  modalData?: {
    title: string;
    message: string;
    confirmText?: string;
    abortText?: string;
    positiveAction?: () => void;
  };

  private sub = new Subscription();

  constructor(
    private modalService: ModalService,
    @Inject('MODAL_DATA') public data: any,
    private api: AuthorizedApiService,
  ) {
    this.modalData = data;
  }

  close(value: any = false): void {
    this.modalService.close(value);
  }

  positive(): void {
    if (this.modalData?.positiveAction) {
      this.modalData.positiveAction();
    }
    this.close(true);
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
